<template>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        <span
          class="v2_font_size_20 v2_font_weight_semibold v2_font_Montserrat v2_color_primary_teal"
        >
          Customer User Information
        </span>
        </b-col>

        <b-col cols="12" class="d-flex justify-content-between mt-2">
            <b-form @submit.prevent="handleSubmit" class="col-md-12">
                <recruiter-form
                    ref="recruiterForm"
                    :initial-data="user"
                />
                <b-form-row>
                    <b-col cols="6" class="pull-right mt-3 position-relative">
                        <b-button
                            variant="primary"
                            type="submit"
                            class="btn btn-next px-5 position-absolute r-0"
                            :disabled="isSavingInProgress"
                            @click1="handleButtonClick('Back')"
                            @click="changePropValue('Back')"
                        >
                            <b-spinner v-if="isSavingInProgress" small />
                            <span v-else><i class="mdi mdi-arrow-left-bold ml-1"></i> Back</span>
                        </b-button>
                        </b-col>
                        <b-col cols="6" class="d-flex justify-content-right mt-3">
                        <b-button
                            variant="primary"
                            type="submit"
                            class="btn btn-next px-5"
                            :disabled="isSavingInProgress"
                            @click1="handleButtonClick('Next')"
                            @click="changePropValue('Next')"
                        >
                            <b-spinner v-if="isSavingInProgress" small />
                            <span v-else>Next <i class="mdi mdi-arrow-right-bold ml-1"></i></span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-col>
    </b-row>
</template>

<script>
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import RecruiterForm from '@/components/recruiter/form/RecruiterForm';
import { HalfCircleSpinner } from 'epic-spinners';
import { SET_USER_MUTATION } from '@/store';

export default {
  name: 'RecruiterEditProfile',
  props: {
    isShowStep: {
      type: Number,
      default: false
    }
  },
  components: {
    RecruiterForm,
    HalfCircleSpinner,
  },
  data: function () {
    return {
      profileData: null,
      isSavingInProgress: false,
    };
  },
  created: function () {
    this.getRecruiterProfile();
  },
  computed: {
    user: function () {
      return this.$store.state.user ? this.$store.state.user : {};
    },
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
    // computedIsShowStep() {
    //   // Use the prop in the computed property without modifying it directly
    //   return this.isShowStep==2;
    // }
  },
  methods: {
    handleSubmit: async function () {
      this.$refs.recruiterForm.validate();
      if (this.$refs.recruiterForm.hasErrors()) {
        return;
      }
      this.isSavingInProgress = true;
      try {
        const profileData = this.$refs.recruiterForm.getData();
        const { user, profile } = await Api.updateRecruiterProfile(profileData);
        this.$store.state.user.profile = profile;
        this.profileData = {
          ...user,
          ...profile,
        };
        
        this.$store.commit(SET_USER_MUTATION, {
          ...this.$store.state.user,
          ...user,
        });
        this.$toasted.success('Profile is updated', {
          duration: 3000,
        }); 
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.isSavingInProgress = false;
      }
    },
    handleButtonClick(label) {
      // Perform actions based on the button's label
      if (label === 'Next') {
        this.isShowStep=3;
        //this.$router.push("/recruiter/review-job-opportunity");
      } else if (label === 'Back') {
        // Do something for the "Back" button
        this.$router.push("/recruiter/ico");
      }
    },
    changePropValue(label) {
      // Emit an event to notify the parent component of the change
      if (label === 'Next') {
        this.$emit('updatePropValue',3);
      }else if (label === 'Back') {
        // Do something for the "Back" button
        this.$emit('updatePropValue', 1);
      }
    },
    getRecruiterProfile: async function () {
      this.$wait.start(this.loaderId);
      try {
        this.profileData = await Api.getRecruiterProfile();
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
  },
};
</script>

<style scoped>

.position-relative{
  position:relative;
}
.position-absolute{
  position:absolute
} 
.r-0{
  right:0;
}
.btn-next{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #b0d27b !important;
  border: 1px solid #00586f !important;
  opacity: 1;
  border-radius: 20px;
}
.btn-next i{
  font-size:15px;
}
</style>